module.exports = __webpack_public_path__ + "static/media/check-fill.5457d2a2.svg";